import { render } from "./ViewSpace.vue?vue&type=template&id=8a33a712&scoped=true"
import script from "./ViewSpace.vue?vue&type=script&lang=js"
export * from "./ViewSpace.vue?vue&type=script&lang=js"

import "./ViewSpace.vue?vue&type=style&index=0&id=8a33a712&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a33a712"]])

export default __exports__